import { makeStyles, tokens } from '@fluentui/react-components';
import { fontScale } from '@/theme';

export const useFilmingApprovalPanelStyles = makeStyles({
  container: {
    backgroundColor: tokens.colorBrandBackground2Hover,
    borderLeft: `4px solid ${tokens.colorBrandBackground}`,
    borderTop: `1px solid ${tokens.colorBrandStroke2}`,
    borderRight: `1px solid ${tokens.colorBrandStroke2}`,
    borderBottom: `1px solid ${tokens.colorBrandStroke2}`,
    borderRadius: tokens.borderRadiusMedium,
    paddingTop: tokens.spacingVerticalL,
    paddingBottom: tokens.spacingVerticalL,
    paddingLeft: tokens.spacingHorizontalXL,
    paddingRight: tokens.spacingHorizontalXL,
    marginTop: tokens.spacingVerticalS,
    marginBottom: tokens.spacingVerticalXS,
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
  },
  /**
   * Figma 2026 filming approval callout (node `1-622` / `1-410`): soft canvas
   * with neutral border, no accent left bar; relies on the section icon chip
   * rendered by the wrapper to convey purpose.
   */
  containerFigma: {
    backgroundColor: tokens.colorBrandBackground2,
    borderLeftWidth: '1px',
    borderLeftStyle: 'solid',
    borderLeftColor: tokens.colorNeutralStroke1,
    borderTopColor: tokens.colorNeutralStroke1,
    borderRightColor: tokens.colorNeutralStroke1,
    borderBottomColor: tokens.colorNeutralStroke1,
    borderRadius: '0.5rem',
  },
  title: {
    fontWeight: tokens.fontWeightBold,
    fontSize: fontScale.subtitle,
    color: tokens.colorNeutralForeground1,
  },
  description: {
    fontSize: fontScale.body,
    lineHeight: tokens.lineHeightBase300,
    color: tokens.colorNeutralForeground1,
  },
  downloadButton: {
    alignSelf: 'flex-start',
    marginTop: tokens.spacingVerticalS,
    marginBottom: tokens.spacingVerticalS,
  },
  contactLine: {
    fontSize: fontScale.body,
    lineHeight: tokens.lineHeightBase300,
    display: 'flex',
    alignItems: 'baseline',
    gap: tokens.spacingHorizontalXS,
  },
  contactLabel: {
    fontWeight: tokens.fontWeightBold,
    color: tokens.colorNeutralForeground1,
  },
  contactLinkFigma: {
    color: tokens.colorBrandStroke1,
  },
  contactLink: {
    color: tokens.colorBrandForeground2Hover,
    textDecoration: 'none',
    ':hover': {
      textDecoration: 'underline',
    },
  },
});
